export default __webpack_public_path__ + "static/06.07-c06aa8ee27d1ca6185f54975412301b8.png";